import React from 'react'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

import Button from '@/common/components/Button'
import Form from '@/common/components/Form'
import Image from '@/common/components/Image'
import useI18n from '@/common/hooks/useI18n'
import placeImage from '@/common/images/place.svg'
import { resolvePath } from '@/common/utils/url'
import PlaceSelectField from '@/modules/property/components/PlaceSelectField'
import { PLACE_DETAIL_PATH } from '@/modules/property/paths'
import { SEARCH } from '@/modules/property/translation'

import { PROJECT_NAME_TITLE, PROJECT_NAME_PLACEHOLDER } from './translation'

const schema = yup.object().shape({
  placeId: yup.string().required(),
})

export interface SearchPlaceByNameFormProps {
  onSubmit?: (values: any) => void
}

const SearchPlaceByNameForm = ({
  onSubmit: _onSubmit,
}: SearchPlaceByNameFormProps) => {
  const { t } = useI18n()
  const navigate = useNavigate()

  const onSubmit = values => {
    navigate(resolvePath(PLACE_DETAIL_PATH, { placeId: values.placeId }))
    _onSubmit?.(values)
  }

  return (
    <Form schema={schema} onSubmit={onSubmit}>
      <Image className='mb-32' src={placeImage} width='100%' height='auto' />
      <PlaceSelectField
        className='mb-20'
        name='placeId'
        label={PROJECT_NAME_TITLE}
        placeholder={PROJECT_NAME_PLACEHOLDER}
      />
      <Button type='submit' variant='gradient' fullWidth>
        {t(SEARCH)}
      </Button>
    </Form>
  )
}

export default SearchPlaceByNameForm
